const t = {
  styleOverrides: {
    root: ({ theme: e }) => ({
      color: e.palette.text.secondary
    }),
    sizeSmall: ({ theme: e }) => ({
      padding: e.spacing(1)
    }),
    sizeMedium: ({ theme: e }) => ({
      padding: e.spacing(1.5)
    }),
    sizeLarge: ({ theme: e }) => ({
      padding: e.spacing(2)
    }),
    disabled: ({ theme: e }) => ({
      color: e.palette.action.disabled
    }),
    selected: ({ theme: e }) => ({
      backgroundColor: e.palette.action.selected,
      color: e.palette.text.primary
    })
  }
};
export {
  t as toggleButton
};
//# sourceMappingURL=toggleButton.mjs.map
